export function eventSearch() {
	const searchInput = document.getElementById("events-search-input");
	const resultsContainer = document.getElementById("events-search-results");

	if (!searchInput || !resultsContainer) return;

	let events = [];

	// Fetch events from WordPress via AJAX
	fetch("/wp-admin/admin-ajax.php?action=get_events_list")
		.then((res) => res.json())
		.then((data) => {
			events = data;
		});

	// Handle input
	searchInput.addEventListener("input", function () {
		const query = this.value.toLowerCase().trim();
		resultsContainer.innerHTML = "";

		if (!query) {
			resultsContainer.style.display = "none";
			return;
		}

		const filtered = events.filter(event =>
			event.title.toLowerCase().includes(query)
		);

		if (filtered.length === 0) {
			resultsContainer.innerHTML = "<li>No results found</li>";
		} else {
			filtered.forEach(event => {
				const li = document.createElement("li");
				li.innerHTML = `<a href="${event.link}">${event.title}</a>`;
				resultsContainer.appendChild(li);
			});
		}

		resultsContainer.style.display = "block";
	});

	document.addEventListener("click", function (e) {
		if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
			resultsContainer.style.display = "none";
		}
	});
}
